import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Label } from 'semantic-ui-react';
import { FiFilter } from 'react-icons/fi';

// Selectors
// @ts-ignore
import { makeSelectQueryStringValuesCount } from 'workspaces/react-router-selectors';

export interface OwnProps {
    style?: {};
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

interface StateProps {
    count?: number;
}

type IProps = StateProps & OwnProps;

export class FilterButton extends React.PureComponent<IProps> {
    render(): React.ReactElement {
        const { style, onClick, count, ...props } = this.props;
        return (
            <Button
                {...props}
                dispatch={undefined}
                circular
                icon
                onClick={onClick}
                style={{
                    ...style,
                    padding: 0,
                    background: 'transparent',
                    boxShadow: 'none',
                    marginLeft: 5,
                    position: 'relative'
                }}
            >
                <FiFilter size="24" style={{ verticalAlign: 'middle' }} />
                {!!count && (
                    <Label circular color="red" floating size="mini">
                        {count}
                    </Label>
                )}
            </Button>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    count: makeSelectQueryStringValuesCount([
        'pickTypeName',
        'varieties',
        'groups',
        'people',
        'entities',
        'schemas',
        'workTypes',
        'users',
        'roles'
    ])
});

export default connect<StateProps, OwnProps>(mapStateToProps)(FilterButton);
